function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Amex = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H39.9994V40H0V0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4905 33.6707V19.338L40.0001 19.3609V23.32L37.0517 26.4709L40.0001 29.6507V33.6938H35.2926L32.7909 30.9331L30.3069 33.7044L14.4905 33.6707Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1943 32.0993V20.9153H25.6773V23.4915H19.2647V25.2404H25.5244V27.7742H19.2647V29.492H25.6773V32.0993H16.1943Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6296 32.0993L30.8769 26.5009L25.6296 20.9155H29.6909L32.8973 24.4602L36.1128 20.9155H39.9997V21.0035L34.8642 26.5009L39.9997 31.9406V32.0993H36.0737L32.8104 28.5191L29.5807 32.0993H25.6296Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.679 6.61644H21.828L23.9878 11.5207V6.61644H31.5792L32.8883 10.2909L34.2018 6.61644H39.9987V20.9491H9.36353L15.679 6.61644Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8437 8.17359L11.8813 19.3483H15.2849L16.2211 17.1105H21.2939L22.2294 19.3483H25.7176L20.7759 8.17359H16.8437ZM17.2702 14.6027L18.7584 11.0454L20.2455 14.6027H17.2702Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6719 19.3462V8.17179L30.456 8.18823L32.9178 15.058L35.3955 8.17179H39.9999V19.3465L37.037 19.3725V11.6964L34.2402 19.3465H31.5358L28.6809 11.6705V19.3465L25.6719 19.3462Z",
    fill: "#016FD0"
  })]
}));
Amex.displayName = 'Amex';
//# sourceMappingURL=Amex.js.map